import { ArrowDown } from "lucide-react";
import { fmt } from "@/data/offer";

export const ValueContrast = ({ value, price, dark = false, onRed = false, compact = false, testId = "value-contrast" }) => {
  const muted = dark ? "text-white/55" : "text-ink/55";
  const rule = dark ? "border-white/15" : "border-ink/15";
  const accent = onRed ? "text-white" : "text-red";
  const strike = onRed ? "decoration-white" : "decoration-red";
  return (
    <div data-testid={testId} className={`${compact ? "space-y-4" : "space-y-6"}`}>
      <div>
        <p className={`text-[11px] font-semibold uppercase tracking-[0.2em] ${muted}`}>Wartość produktów osobno</p>
        <p
          data-testid={`${testId}-value`}
          className={`font-display mt-1 leading-none line-through ${strike} decoration-[3px] ${
            compact ? "text-4xl sm:text-5xl" : "text-5xl sm:text-6xl lg:text-7xl"
          } ${dark ? "text-white/85" : "text-ink/85"}`}
        >
          {fmt(value)}
        </p>
      </div>
      <div className={`flex items-center gap-4 border-t ${rule} pt-4`}>
        <ArrowDown className={`h-4 w-4 ${accent}`} strokeWidth={2.5} />
        <div>
          <p className={`text-[11px] font-semibold uppercase tracking-[0.2em] ${muted}`}>Twój abonament</p>
          <p className={`font-display mt-1 leading-none ${accent} ${compact ? "text-3xl sm:text-4xl" : "text-4xl sm:text-5xl"}`}>
            <span data-testid={`${testId}-price`}>{fmt(price)}</span> <span className="font-sans text-sm font-medium tracking-normal">/ rok</span>
          </p>
        </div>
      </div>
    </div>
  );
};
